(function () {
  function initVideoCarousel(root) {
    var container = root.querySelector('.video_container');
    if (!container) return;

    var slideCount = parseInt(container.getAttribute('data-blocks'), 10) || 0;
    if (slideCount <= 1) return;

    var listEl = root.querySelector('.video_list');
    var prevEl = root.querySelector('.swiper_button_prev');
    var nextEl = root.querySelector('.swiper_button_next');
    var scrollbarEl = root.querySelector('.swiper-scrollbar');

    if (!listEl || typeof Swiper === 'undefined') return;

    var displayCount = Math.min(3, Math.max(1, slideCount));

    new Swiper(listEl, {
      slidesPerView: displayCount,
      spaceBetween: 24,
      cssMode: true,
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      pagination: scrollbarEl
        ? {
            el: scrollbarEl,
            type: 'progressbar',
            clickable: true,
          }
        : undefined,
      mousewheel: true,
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
      breakpoints: {
        989: {
          slidesPerView: displayCount,
          slidesPerGroup: 2,
        },
        750: {
          slidesPerView: displayCount >= 2 ? 2 : 1,
          slidesPerGroup: 1,
        },
        100: {
          slidesPerView: displayCount > 1 ? 1.2 : 1,
          slidesPerGroup: 1,
        },
      },
    });
  }

  function initAll() {
    document.querySelectorAll('video-carousel[data-section-id]').forEach(initVideoCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('video-carousel[data-section-id]').forEach(initVideoCarousel);
  });
})();
